module.exports = __webpack_public_path__ + "img/icon-question-mark-blue.2a7038e5.svg";